import { render } from "./CardForList.vue?vue&type=template&id=3fea1b60&scoped=true"
import script from "./CardForList.vue?vue&type=script&lang=js"
export * from "./CardForList.vue?vue&type=script&lang=js"

import "./CardForList.vue?vue&type=style&index=0&id=3fea1b60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fea1b60"]])

export default __exports__